@if (title) {
  <span class="text-sm font-semibold">{{ title }}</span>
}
@if (!disabled) {
  <phoenix-server-side-autocomplete
    [title]="label"
    [control]="control"
    [serverCallback]="sourceAutocomplete"
    (valueChange)="sourceChange($event)"
    [attrToSave]="showChips ? null : attrToSave"
    [attrFilter]="showChips ? null : 'name'"
    [showClearButton]="true"
    [selectedOption]="source"
    [loadingList]="loadingSources || isRefreshing"
    [customFilter]="sourceFilter"
    [optionHtml]="getOptionHtml"
    [disabled]="disabled"
    [cleanAfterSelect]="showChips"
    [refresh]="refresh"
  >
  </phoenix-server-side-autocomplete>
}

@if (showChips) {
  <phoenix-chips
    [control]="displayChipsControl"
    [filterList]="notRemovableSource"
    [readonly]="true"
    [displayValueFormat]="customFormatFunction"
    [disabled]="disabled"
  >
    <ng-content></ng-content>
  </phoenix-chips>
}
